module.exports = __webpack_public_path__ + "media/schliecker-heise-theke.318862b5.wav";